import cookBookRedirects from '../Cookbook/redirects';
import contactRedirects from '../Contact/redirects';
import contentRedirects from '../Content/redirects';
import knowledgeRedirects from '../Knowledge/redirects';
import goalSettingsRedirects from '../GoalSettings/redirects';
import measurementsRedirects from '../Measurements/redirects';
import biometricSettingsRedirects from '../BiometricSettings/redirects';
import nutritionSettingsRedirects from '../NutritionSettings/redirects';

const allRedirects = [
  ...cookBookRedirects,
  ...contactRedirects,
  ...contentRedirects,
  ...knowledgeRedirects,
  ...goalSettingsRedirects,
  ...measurementsRedirects,
  ...biometricSettingsRedirects,
  ...nutritionSettingsRedirects,
];

export default allRedirects;
